import { render, staticRenderFns } from "./FTabs.vue?vue&type=template&id=60974c5c&"
import script from "./FTabs.vue?vue&type=script&lang=js&"
export * from "./FTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports